/** Low PPN: the supervisor's resow decision (docs/designs/got-ppn-resow.md). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { LowPpnPage } from "@/features/got/components/low-ppn-page";

export const Route = createFileRoute("/_app/quality/got/low-ppn")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.resow_decide"))
      throw redirect({ to: "/" });
  },
  component: LowPpnPage,
});
